import type { TvShow, TvShowEpisode, TvShowSeason } from '@setplex/tria-api'

interface GetSeasonPaymentExternalIdParams {
  season?: TvShowSeason | null
  show?: TvShow | null
}
export const getSeasonPaymentExternalId = ({
  season,
  show,
}: GetSeasonPaymentExternalIdParams) => {
  if (season?.seasonPriceSettings?.length) return season.externalId

  if (season?.tvShowPriceSettings?.length) return show?.externalId

  return null
}

interface GetEpisodePaymentExternalIdParams {
  episode: TvShowEpisode | null
  season: TvShowSeason | null | undefined
  show: TvShow | null | undefined
}
export const getEpisodePaymentExternalId = ({
  episode,
  season,
  show,
}: GetEpisodePaymentExternalIdParams) => {
  if (episode?.episodePriceSettings?.length) return episode.externalId

  if (episode?.seasonPriceSettings?.length) return season?.externalId

  if (episode?.tvShowPriceSettings?.length) return show?.externalId

  return null
}
